import QuestionPage from '@app-studio-web/ui/pages/QuestionPage'
import { useTranslation } from 'react-i18next'
import { useSubmit } from 'react-router-dom'

export default function QuestionCuisinePage() {
  const submit = useSubmit()
  const { t } = useTranslation()

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    submit(event.currentTarget)
  }

  return (
    <QuestionPage
      heading={t('pages.onboarding.questionCuisine.heading')}
      buttons={[
        {
          text: t('pages.onboarding.questionCuisine.button1'),
          value: 'american',
        },
        {
          text: t('pages.onboarding.questionCuisine.button2'),
          value: 'italian',
        },
        {
          text: t('pages.onboarding.questionCuisine.button3'),
          value: 'mexican',
        },
        {
          text: t('pages.onboarding.questionCuisine.button4'),
          value: 'chinese',
        },
        {
          text: t('pages.onboarding.questionCuisine.button5'),
          value: 'japanese',
        },
        {
          text: t('pages.onboarding.questionCuisine.button6'),
          value: 'indian',
        },
        {
          text: t('pages.onboarding.questionCuisine.button7'),
          value: 'thai',
        },
        {
          text: t('pages.onboarding.questionCuisine.button8'),
          value: 'mediterranean',
        },
        {
          text: t('pages.onboarding.questionCuisine.button9'),
          value: 'french',
        },
        {
          text: t('pages.onboarding.questionCuisine.button10'),
          value: 'korean',
        },
        {
          text: t('pages.onboarding.questionCuisine.button11'),
          value: 'other',
        },
      ]}
      onSubmit={handleSubmit}
    />
  )
}
